import { render, staticRenderFns } from "./Addressbookinfo.vue?vue&type=template&id=008575ee&"
import script from "./Addressbookinfo.vue?vue&type=script&lang=js&"
export * from "./Addressbookinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports